<script>
    // displays following button and changes state when pressed
  import { User } from "sveltefire";
  import Modal from './Modal.svelte';
  import { listId, followingArray } from './stores.js';
  export let publisherId="0";
  let showModal = false;

  let isFollowing = false;
  let followingDisplay="Follow";
  let tempDisplay;
  function takeAction(){
    // console.log("@take Action pubId="+publisherId+" isFollowing="+isFollowing+"  followingArray="+$followingArray);
    if (isFollowing){
      followingArray.update(n => n.filter(item => item !== publisherId));
    }else{
      //alert($followingArray.length)
      if ($followingArray.length<8){
        followingArray.update(n => [...n, publisherId]) ;//add current publisherId to following
        if ($followingArray.length == 8) {
          // alert(showModal)
          showModal = true;
        }
      } else {
        // alert('Following too many followingArray='+$followingArray);
        showModal = true;
      }
    }
    isFollowing=!isFollowing;
    console.log("@take Action pubId="+publisherId+" isFollowing="+isFollowing+"  followingArray="+$followingArray);
    // update database here
  }
  $: if ($followingArray.includes (publisherId) ){
    isFollowing=true;
    tempDisplay=followingDisplay;
    followingDisplay="Following";
  }else{
    followingDisplay="Follow";
  }
  const gotoFollow = function(){
    listId.set($followingArray)
  }
</script>

<User let:user let:auth>
    <span class="signed-in">
    {#if $followingArray.length<8  || isFollowing}
    <button class="{isFollowing ? "followBut" : 'followingBut'}"
    on:click="{takeAction}">{followingDisplay}</button>
    {/if}
    </span>
</User>

{#if showModal}
<Modal on:close="{() => showModal = false}">
  <h2 slot="header">Following Your Eighth Newsletter:</h2>
  <div>
    <p>Reading.email allows you to follow upto eight newsletters. 
      You've just started following your eighth which is the maximum.
      In order to follow more, you'll have to unfollow some newsletters 
      which you can do on  your following page.
      Click on <span class="gotoFollow" on:click={gotoFollow}>following</span> to see your following page.
    </p>
  </div>
</Modal>
{/if}

<style>
  .followBut {background-color: cornsilk; color: cornflowerblue;}
  .followingBut {background-color: cornflowerblue; color: cornsilk;}
  button {border-color: cornflowerblue; width: 6rem; border-radius: 5px;}
  .gotoFollow {text-decoration: underline; color: blue;}
</style>